import {createSlice} from "@reduxjs/toolkit";

const initialState={
   open:false,
   isHovered:false,
   hoveredThumbnail:null,
   thumbnailPath:null,
   imagePath:null,
   packshotPath:null,
   imageName:null,
   similarSkusDetails:[],

  }

const popoverSlice = createSlice({
    name: "popover",
    initialState,
    reducers: {
      setOpen:(state,action)=>{
        state.open=action.payload;
      },
      setIsHovered:(state,action)=>{
        state.isHovered=action.payload
      },
      setHoveredThumbnail:(state,action)=>{
        state.hoveredThumbnail=action.payload
      },
      setSimilarSkusDetails:(state,action)=>{
        state.similarSkusDetails=action.payload
      },
      resetPopOver:(state,action)=>{
       state.hoveredThumbnail=null;
       state.open=false;
       state.isHovered=false;
       state.thumbnailPath=null;
       state.packshotPath=null;
       state.imageName=null;
       state.similarSkusDetails=[];
       state.imagePath=null
      }
    }
  });

export const {setOpen,setIsHovered,setHoveredThumbnail,setSimilarSkusDetails,resetPopOver}= popoverSlice.actions;

export default popoverSlice.reducer;